<div class="px-row" *ngIf="loading">
    <div class="px-col-12 cover-spin">
      <div style="text-align: center; margin-top: 50vh;">
        <phx-loading color="#0000ff"></phx-loading>
      </div>
    </div>
  </div>